const SAMPLE_FLASK_TYPES = {
  FILTRE: "FILTRE",
  BARBOTAGE: "BARBOTAGE",
  RENDEMENT: "RENDEMENT",
  RINCAGE: "RINCAGE",
  BLANC_FILTRAGE: "BLANC_FILTRAGE",
  BLANC_BARBOTAGE: "BLANC_BARBOTAGE",
  BLANC_RINCAGE: "BLANC_RINCAGE",
  AUTRE_SUPPORT: "AUTRE_SUPPORT",
};
const SAMPLE_FLASK_TYPES_SHORT_NAMES = {
  FILTRE: "FI",
  BARBOTAGE: "BA",
  RINCAGE: "RI",
  RENDEMENT: "RDT",
  BLANC_FILTRAGE: "BF",
  BLANC_BARBOTAGE: "BB",
  BLANC_RINCAGE: "BR",
  AUTRE_SUPPORT: "AS",
};

export { SAMPLE_FLASK_TYPES, SAMPLE_FLASK_TYPES_SHORT_NAMES };
